module.exports = __webpack_public_path__ + "static/media/angkur_logo.cf158a1d.svg";